import { Divider, Drawer, List, IconButton, Box } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import SmlIcon from "../assets/svg/sml.svg";
import VectorIcon from "../assets/svg/Vector.svg";
import DrawerMenuItem from "./DrawerMenuItem";
import { useDrawerToggle } from "../hooks/useDrawerToggle";
import { useFilteredDrawerItems } from "./userDrawerItems";

function MainDrawer() {
    const { drawerOpen, toggleDrawer } = useDrawerToggle();
    const drawerItems = useFilteredDrawerItems();

    console.log(drawerItems, "hahahah")

    return (
        <Drawer
            anchor="left"
            variant="permanent"
            open={drawerOpen}
            sx={{
                width: drawerOpen ? "260px" : "70px",
                flexShrink: 0,
                overflow: "hidden",
                "& .MuiDrawer-paper": {
                    width: drawerOpen ? "260px" : "70px",
                    boxSizing: "border-box",
                    transition: "width 0.3s",
                    overflow: "hidden",
                    borderTopRightRadius: "30px",
                    borderBottomRightRadius: "30px"
                },
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: drawerOpen ? "flex-end" : "center",
                    padding: 1,
                    backgroundColor: "#E50019",
                    overflow: "hidden",
                }}
            >
                <IconButton onClick={toggleDrawer}>
                    {drawerOpen ? (
                        <MenuIcon sx={{ color: "#fff" }} />
                    ) : (
                        <img src={VectorIcon} alt="Vector Logo" width="40px" />
                    )}
                </IconButton>
            </Box>

            {drawerOpen && (
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginTop: -7,
                        backgroundColor: "#E500",
                        marginBottom: 0,
                        overflow: "hidden",
                        width: "100%",
                        padding: "0 16px",
                    }}
                >
                    <IconButton onClick={toggleDrawer}>
                        <img src={SmlIcon} alt="Another logo" style={{ width: "100%", maxWidth: "260px" }} />
                    </IconButton>
                </Box>
            )}

            <List
                sx={{
                    p: 0,
                    pb: 1,
                    flexGrow: 1,
                    minHeight: 0,
                    overflowY: "auto",
                    // The collapsed rail is only 70px wide, so a default (~15px)
                    // scrollbar eats enough of it to clip the icons -- keep it thin.
                    scrollbarWidth: "thin",
                    "&::-webkit-scrollbar": { width: "6px" },
                    "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "rgba(0, 0, 0, 0.2)",
                        borderRadius: "3px",
                    },
                    overflowX: "hidden",
                }}
            >
                {drawerItems.map((item, index) => (
                    <DrawerMenuItem item={item} drawerOpen={drawerOpen} key={`${index}-menuitem`} />
                ))}
            </List>
        </Drawer>
    );
}

export default MainDrawer;